import Axios from "axios";
import React from "react"
import { sortCaret } from "../../../_metronic/_helpers";
import axiosCancel from 'axios-cancel';

axiosCancel(Axios);
const url_clients = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/clients";
function ActionsColumnFormatter(cellContent, row, rowIndex) {
  const states = row.states || []
  if (states.length > 8) {
    return (
      <>
        {states.slice(0, 6).join(", ")} ...
      </>
    )
  }
  return (
    <>
      {states.join(", ")}
    </>
  )
}
export const columns = [
  {
    dataField: "name",
    text: "Company name",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "description",
    text: "Description",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "states",
    text: "States",
    formatter: ActionsColumnFormatter,
  }
];

export function getClients(setClients) {
  Axios.get(`${url_clients}/find`)
    .then((res) => {
      const clients = res.data.payload;
      setClients(clients);
    })
    .catch((err) => {
      console.log(err)
    });
}
export function getClient(uid) {
  return Axios.get(`${url_clients}/find/${uid}`)

}
export function updateClient(client) {
  if (client.uid) {

    return Axios.put(`${url_clients}/update/${client.uid}`, client);
  } else {
    return Axios.post(`${url_clients}/create`, client);

  }
}
export function deleteClient(uid) {
  return Axios.delete(`${url_clients}/delete/${uid}`)
}